module.exports = __webpack_public_path__ + "img/new-tanfeethi.0eb4a17a.jpg";